import {
  GroupEnum,
  GroupLabelsEnum,
  GroupPermissionResponse,
  UserPermissionByIdResponse,
} from "../permissionTypes";
import { vessels } from "../../configServer/mocks/vessels.mock";

const getGroupShapeAdmin: GroupPermissionResponse = {
  id: 1,
  name: GroupLabelsEnum.SHAPE_ADMIN,
  recommended_position: "Shape Admin",
  permissions: [
    {
      description: "Identification",
      name: "Identification",
      enable: true,
      id: 1,
    },
    {
      description: "1. Initiation",
      name: "1. Initiation",
      enable: true,
      id: 2,
    },
    {
      description: "2. Evaluation and Risk Assessment",
      name: "2. Evaluation and Risk Assessment",
      enable: true,
      id: 3,
    },
    {
      description: "3. Review",
      name: "3. Review",
      enable: true,
      id: 4,
    },
    {
      description: "4. Approval",
      name: "4. Approval",
      enable: true,
      id: 5,
    },
    {
      description: "5. Mitigation Action Implementation",
      name: "5. Mitigation Action Implementation",
      enable: true,
      id: 6,
    },
    {
      description: "6. Re-assessment for Closure",
      name: "6. Re-assessment for Closure",
      enable: true,
      id: 7,
    },
    {
      description: "7. Closure Verification",
      name: "7. Closure Verification",
      enable: true,
      id: 8,
    },
    {
      description: "8. Closure Approval",
      name: "8. Closure Approval",
      enable: true,
      id: 9,
    },
    {
      description: "Extend CTO Period",
      name: "Extend CTO Period",
      enable: true,
      id: 10,
    },
    {
      description: "Close CTO",
      name: "Close CTO",
      enable: true,
      id: 11,
    },
    {
      description: "Change WO status",
      name: "Change WO status",
      enable: true,
      id: 12,
    },
    {
      description: "Manage request",
      name: "Manage request",
      enable: true,
      id: 13,
    },
    {
      description: "Change other user's permissions",
      name: "Change other user's permissions",
      enable: true,
      id: 14,
    },
    {
      description: "Delete all Vessel CTOs",
      name: "Delete all Vessel CTOs",
      enable: true,
      id: 15,
    },
    {
      description: "Group CTO",
      name: "Group CTO",
      enable: true,
      id: 17,
    },
  ],
};
const getGroupVesselAdmin: GroupPermissionResponse = {
  id: 2,
  name: GroupLabelsEnum.VESSEL_ADMIN,
  recommended_position: "Shape Admin",
  permissions: [
    {
      description: "Identification",
      name: "Identification",
      enable: true,
      id: 1,
    },
    {
      description: "1. Initiation",
      name: "1. Initiation",
      enable: true,
      id: 2,
    },
    {
      description: "2. Evaluation and Risk Assessment",
      name: "2. Evaluation and Risk Assessment",
      enable: true,
      id: 3,
    },
    {
      description: "3. Review",
      name: "3. Review",
      enable: true,
      id: 4,
    },
    {
      description: "4. Approval",
      name: "4. Approval",
      enable: true,
      id: 5,
    },
    {
      description: "5. Mitigation Action Implementation",
      name: "5. Mitigation Action Implementation",
      enable: true,
      id: 6,
    },
    {
      description: "6. Re-assessment for Closure",
      name: "6. Re-assessment for Closure",
      enable: true,
      id: 7,
    },
    {
      description: "7. Closure Verification",
      name: "7. Closure Verification",
      enable: true,
      id: 8,
    },
    {
      description: "8. Closure Approval",
      name: "8. Closure Approval",
      enable: true,
      id: 9,
    },
    {
      description: "Extend CTO Period",
      name: "Extend CTO Period",
      enable: true,
      id: 10,
    },
    {
      description: "Close CTO",
      name: "Close CTO",
      enable: true,
      id: 11,
    },
    {
      description: "Change WO status",
      name: "Change WO status",
      enable: true,
      id: 12,
    },
    {
      description: "Manage request",
      name: "Manage request",
      enable: true,
      id: 13,
    },
    {
      description: "Change other user's permissions",
      name: "Change other user's permissions",
      enable: true,
      id: 14,
    },
  ],
};

const getGroupProcessSafetyLead: GroupPermissionResponse = {
  id: 3,
  name: GroupLabelsEnum.PROCESS_SAFETY_LEAD,
  recommended_position: "Shape Admin",
  permissions: [
    {
      description: "3. Review",
      name: "3. Review",
      enable: true,
      id: 4,
    },
    {
      description: "7. Closure Verification",
      name: "7. Closure Verification",
      enable: true,
      id: 8,
    },
    {
      description: "Change WO status",
      name: "Change WO status",
      enable: true,
      id: 12,
    },
  ],
};

const getGroupOpsManage: GroupPermissionResponse = {
  id: 4,
  name: GroupLabelsEnum.OPS_MANAGER,
  recommended_position: "Shape Admin",
  permissions: [
    {
      description: "4. Approval",
      name: "4. Approval",
      enable: true,
      id: 5,
    },
    {
      description: "8. Closure Approval",
      name: "8. Closure Approval",
      enable: true,
      id: 9,
    },
    {
      description: "Change WO status",
      name: "Change WO status",
      enable: true,
      id: 12,
    },
  ],
};

export const getUserPermission = (): UserPermissionByIdResponse => ({
  name: "Joan Daniels",
  email: "Joan.Daniels@modec.com",
  position: "External Consultant",
  id: 1,
  user_groups: [
    {
      group_id: GroupEnum.SHAPE_ADMIN,
      id: 77,
      permissions: getGroupShapeAdmin.permissions,
      vessels: ["All", ...vessels.flatMap((vessel) => vessel.vessel_code)],
    },
  ],
});
